<button mat-stroked-button type="button" class="mcp-trigger" [matMenuTriggerFor]="menu"
        (click)="beginEdit()">
  <mat-icon>calendar_today</mat-icon>
  <span>
    @if (appliedPresetLabel) {
      {{ appliedPresetLabel | translate }}
    } @else {
      {{ appliedRangeText || ('App.Picker.SelectMonths' | translate) }}
    }
  </span>
  <mat-icon class="mcp-chev">arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu" class="drp-menu" xPosition="before">
  <!-- stopPropagation keeps clicks inside the panel (calendar nav, month tiles) from closing the menu -->
  <div class="mcp-panel" (click)="$event.stopPropagation()">
    <div class="mcp-presets">
      <button type="button" class="mcp-preset" *ngFor="let p of presets"
              [class.mcp-on]="activePreset === p.key" (click)="applyPreset(p)">
        {{ p.label | translate }}
      </button>
    </div>

    <div class="mcp-cal">
      <mat-calendar startView="year"
                    [startAt]="startAt"
                    [maxDate]="maxDate"
                    [dateClass]="dateClass"
                    (monthSelected)="onMonthSelected($event)">
      </mat-calendar>

      <div class="mcp-foot">
        <span class="mcp-range">{{ rangeText || ('App.Picker.PickMonthRange' | translate) }}</span>
        <div class="mcp-foot-actions">
          <button type="button" class="mcp-clear" (click)="clear()">{{ 'App.Picker.Clear' | translate }}</button>
          <button mat-flat-button color="primary" class="mcp-apply" type="button"
                  [disabled]="!fromMonth || !toMonth" (click)="apply()">
            {{ 'App.Picker.Apply' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-menu>
